import { type AppState } from 'src/redux/app/app.store'
import { type User } from 'src/redux/permissions/permissions.types'

export const selectUser = (state: AppState): User | null => state.permissions.user
export const selectIsUserChanged = (state: AppState): boolean => state.permissions.isUserChanged
